import "./App.css";
import "./assets/css/FontStyles.css";
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { useState } from "react";
import NavigationBar from "./components/general/Navbar/NavigationBar";
import Footer from "./components/general/HomeLayout/Footer/Footer";

/* ==================== PUBLIC ==================== */
import Home from "./screens/user/Home/home";
import AboutUs from "./components/general/AboutUs/AboutUs";
import Contact from "./components/general/ContactUs/contact";
import Courses from "./screens/student/courses/Courses";
import Mentors from "./screens/mentor/Mentors";
import MentorDetail from "./screens/mentor/Mentordetail";
import CodeArena from "./screens/student/CodeArena/CodeArena2.js";
import HowMentorshipWorks from "./screens/mentor/HowMentorshipWorks/HowMentorshipWorks";
import ApplyPage from "./screens/general/ApplyPage/ApplyPage";
import UserLogin from "./screens/student/Login/UserLogin";
import UserSignup from "./screens/student/Signup/UserSignup";
import Forgotpassword from "./screens/general/ForgotPassword/ForgotPassword";
import BlogPage from "./screens/general/blog/BlogPage/BlogPage";
import BlogDetailPage from "./screens/general/blog/BlogDetailPage/BlogDetailPage";
import MentorVerification from "./screens/admin/MentorsVerfication/MentorsVerification";
import MentorApplicationForm from "./screens/mentor/MentorApplicationForm/MentorApplicationForm";
import PageNotFound from "./screens/general/NotFound/PageNotFound";
import CareersPage from "./screens/general/Careers/CareersPage";
import HelpSupport from "./components/general/HelpSupport/HelpSupport";
import MentorWizard from "./screens/mentor/MentorWizard/Mentorwizard";
import FAQ from "./components/general/FAQ/Faqpage";
import SystemNotifications from "./components/general/Notifications/SystemNotifications";
/* ==================== ROADMAP ==================== */
import BuildRoadmap from "./screens/student/roadmaps/BuildRoadmap";
import Roadmap from "./screens/student/roadmaps/roadmap";

/* ==================== STUDENT ==================== */

import StudentLayout from "./layouts/Student/MyStudentLayout.js";
import StudentDashboard from "./screens/student/studentdashboard/Dashboard";
import MyCourses from "./screens/student/studentdashboard/MyCourses.js";
import Wishlist from "./screens/student/studentdashboard/Wishlist.js";
import RoadmapsProgress from "./screens/student/studentdashboard/RoadmapsProgress.js";
import MyAssignments from "./screens/student/studentdashboard/MyAssignments.js";
import CodeChallenges from "./screens/student/studentdashboard/CodeChallenges.js";
import AskAI from "./screens/student/studentdashboard/AskAI.js";
import MyMentor from "./screens/student/studentdashboard/MyMentor.js";
import MentorRequestsPage from "./screens/student/studentdashboard/MentorRequestsPage.js";
import Chat from "./screens/student/studentdashboard/ChatList.js";
import StudetnPayments from "./screens/student/studentdashboard/StudentPayments.js";
import StudentReportIssue from "./screens/student/studentdashboard/StudentReport.js";
import Leaderboard from "./screens/student/studentdashboard/Leaderboard.js";
import StudentHelpSupport from "./screens/student/studentdashboard/StudentHelpSupport.js";

// ==================== MENTOR DASHBOARD ==================== //

import MentorLoginSignup from "./screens/mentor/mentordashboard/Auth/loginsignup";
import Dashboard from "./screens/mentor/mentordashboard/Dashboard";
import BasicAnalytics from "./screens/mentor/mentordashboard/BasicAnalytics";
import StudentRequests from "./screens/mentor/mentordashboard/StudentRequests";
import StudentReport from "./screens/mentor/mentordashboard/StudentReport";
import Enrolledstudents from "./screens/mentor/mentordashboard/Enrolledstudents";
import MentorNotifications from "./screens/mentor/mentordashboard/Notifications";
import RoadmapSuggestions from "./screens/mentor/mentordashboard/RoadmapSuggestions";
import StudentQuestions from "./screens/mentor/mentordashboard/StudentQuestions";
import Assignments from "./screens/mentor/mentordashboard/Assignments";
import MentorChatList from "./screens/mentor/mentordashboard/ChatList";
import Mentorprofile from "./screens/mentor/mentordashboard/Mentorprofile";
import Mentorhelpsupport from "./screens/mentor/mentordashboard/Mentorhelpsupport";
import Paymentreceived from "./screens/mentor/mentordashboard/Paymentreceived";

/* ==================== ADMIN ==================== */
import AdminLogin from "./screens/admin/AdminLogin/AdminLogin";
import AdminDashboard from "./screens/admin/Dashboard/AdminDashboard";
import SubAdmin from "./screens/admin/SubAdmin/SubAdmin";
import Users from "./screens/admin/Users/Users";
import Students1 from "./screens/admin/Users/Students.js";
import Mentors1 from "./screens/admin/Users/Mentors.js";
import Roadmaps from "./screens/admin/Roadmaps/Roadmaps";
import CoursesAdmin from "./screens/admin/CoursesAdmin/CoursesAdmin";
import Categories from "./screens/admin/Categories/Categories";
import MentorsVerification from "./screens/admin/MentorsVerfication/MentorsVerification";
import Notifications from "./screens/admin/Notifications/Notifications";
import AITutor from "./screens/admin/AITutor/AITutor";
import Analytics from "./screens/admin/Analytics/Analytics";
import Reports from "./screens/admin/Reports/Reports";
import Settings from "./screens/admin/Settings/Settings";
import AdminProfile from "./screens/admin/AdminProfile/AdminProfile";
import CreateCourse from "./screens/admin/CreateCourse/CreateCourse";
import CreateRoadmap from "./screens/admin/CreateRoadmap/CreateRoadmap";
import SubAdminForm from "./screens/admin/SubadminForm/SubadminForm";
import EarningsManagement from "./screens/admin/Earnings/EarningsManagement";
import Withdrawals from "./screens/admin/Withdrawals/Withdrawals";
import AdminChat from "./screens/admin/AdminChatPAge/AdminChat";
import Logout from "./screens/admin/Logout/Logout";
import TechifyLayout from "./components/student/AITutor/TechifyLayout/TechifyLayout";

/*==================== AI Tutor =========================*/

import SingleCourse from "./components/admin/temp/SingleCourse.js";
import TechifyAILayout from "./components/student/AITutor/TechifyLayout/TechifyLayout";

/* ==================== APP LAYOUT ==================== */
function AppLayout() {
  const location = useLocation();
  const [isNotFound, setIsNotFound] = useState(false);

  const hideLayout =
    isNotFound ||
    location.pathname.startsWith("/admin") ||
    location.pathname.startsWith("/student") ||
    location.pathname.startsWith("/mentor") ||
    location.pathname.startsWith("/login") ||
    location.pathname.startsWith("/signup") ||
    location.pathname.startsWith("/roadmap") ||
    location.pathname.startsWith("/techify-ai") ||
    location.pathname.startsWith("/single/course") ||
    location.pathname.startsWith("/code-arena") ||
    location.pathname.startsWith("/aboutus") ||
    location.pathname.startsWith("/apply") ||
    location.pathname.startsWith("/build-roadmap") ||
    location.pathname.startsWith("/loginsignup");

  return (
    <>
      {!hideLayout && <NavigationBar />}

      <Routes>
        {/* ================= PUBLIC ================= */}
        <Route path="/" element={<Home />} />
        <Route path="/aboutus" element={<AboutUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/mentors" element={<Mentors />} />
        <Route path="/code-arena" element={<CodeArena />} />
        <Route path="/how-mentorship-works" element={<HowMentorshipWorks />} />
        <Route path="/apply" element={<ApplyPage />} />
        <Route path="/login" element={<UserLogin />} />
        <Route path="/signup" element={<UserSignup />} />
        <Route path="/forgot/password" element={<Forgotpassword />} />
        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog/:id" element={<BlogDetailPage />} />
        <Route path="mentor/verification" element={<MentorVerification />} />
        <Route path="*" element={<PageNotFound onMount={setIsNotFound} />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/help" element={<HelpSupport />} />
        <Route path="/mentor-wizard" element={<MentorWizard />} />
        <Route path="/faqs" element={<FAQ />} />
        <Route path="/notifications" element={<SystemNotifications />} />
        <Route path="/techify-ai " element={<TechifyAILayout />} />
        <Route path="/mentor/application" element={<MentorApplicationForm />} />

        {/* ================= ROADMAP ================= */}
        <Route path="/single/course" element={<SingleCourse />} />
        <Route path="/roadmaps" element={<Roadmap />} />
        <Route path="/build-roadmap" element={<BuildRoadmap />} />

        {/* ================= STUDENT DASHBOARD ================= */}
        <Route path="/Student/Mystudentlayout" element={<StudentLayout />} />
        <Route path="/student/dashboard" element={<StudentDashboard />} />
        <Route path="/Student/my-courses" element={<MyCourses />} />
        <Route path="/Student/wishlist" element={<Wishlist />} />
        <Route
          path="/student/Roadmaps-Progress"
          element={<RoadmapsProgress />}
        />
        <Route path="/Student/my-assignments" element={<MyAssignments />} />
        <Route path="/Student/Code-Challenges" element={<CodeChallenges />} />
        <Route path="/Student/ask-ai" element={<AskAI />} />
        <Route path="/Student/my-mentor" element={<MyMentor />} />
        <Route
          path="/Student/mentor-requests"
          element={<MentorRequestsPage />}
        />
        <Route path="/Student/Chat" element={<Chat />} />
        <Route path="/Student/payments" element={<StudetnPayments />} />
        <Route path="/Student/report-issues" element={<StudentReportIssue />} />
        <Route path="/Student/leaderboard" element={<Leaderboard />} />
        <Route path="/Student/help-support" element={<StudentHelpSupport />} />

        {/* ================= MENTOR DASHBOARD ================= */}
        <Route path="/mentor/dashboard" element={<Dashboard />} />
        <Route path="/mentor-auth" element={<MentorLoginSignup />} />
        <Route
          path="/mentor/dashboard/students"
          element={<Enrolledstudents />}
        />
        <Route
          path="/mentor/dashboard/student-requests"
          element={<StudentRequests />}
        />
        <Route
          path="/mentor/dashboard/student-report"
          element={<StudentReport />}
        />
        <Route
          path="/mentor/dashboard/help-support"
          element={<Mentorhelpsupport />}
        />
        <Route
          path="/mentor/dashboard/analytics"
          element={<BasicAnalytics />}
        />
        <Route
          path="/mentor/dashboard/roadmap"
          element={<RoadmapSuggestions />}
        />
        <Route
          path="/mentor/dashboard/student-questions"
          element={<StudentQuestions />}
        />
        <Route
          path="/mentor/dashboard/notifications"
          element={<MentorNotifications />}
        />
        <Route
          path="/mentor/dashboard/student-assignments"
          element={<Assignments />}
        />
        <Route
          path="/mentor/dashboard/students"
          element={<Enrolledstudents />}
        />
        <Route path="/mentordashboard/chatlist" element={<MentorChatList />} />
        <Route
          path="/mentor/dashboard/payment-received"
          element={<Paymentreceived />}
        />
        <Route
          path="/mentor/dashboard/mentorprofile"
          element={<Mentorprofile />}
        />
        {/* ================= PUBLIC MENTOR PROFILE ================= */}
        <Route path="/mentor/:id" element={<MentorDetail />} />
        {/* ================= ADMIN DASHBOARD ================= */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/sub-admin" element={<SubAdmin />} />
        <Route path="/admin/users" element={<Users />} />
        <Route path="/admin/students" element={<Students1 />} />
        <Route path="/admin/mentors" element={<Mentors1 />} />
        <Route path="/admin/roadmaps" element={<Roadmaps />} />
        <Route path="/admin/courses" element={<CoursesAdmin />} />
        <Route path="/admin/categories" element={<Categories />} />
        <Route
          path="/admin/mentors/verification"
          element={<MentorsVerification />}
        />
        <Route path="/admin/notifications" element={<Notifications />} />
        <Route path="/admin/ai-tutor" element={<AITutor />} />
        <Route path="/admin/analytics" element={<Analytics />} />
        <Route path="/admin/reports" element={<Reports />} />
        <Route path="/admin/settings" element={<Settings />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/admin/create-course" element={<CreateCourse />} />
        <Route path="/admin/create-roadmap" element={<CreateRoadmap />} />
        <Route path="/admin/sub-admins/create" element={<SubAdminForm />} />
        <Route path="/admin/logout" element={<Logout />} />
        <Route path="/admin/earnings" element={<EarningsManagement />} />
        <Route path="/admin/withdrawals" element={<Withdrawals />} />
        <Route path="/admin/chat" element={<AdminChat />} />
        <Route path="/techify-ai" element={<TechifyLayout />} />
      </Routes>

      {!hideLayout && <Footer />}
    </>
  );
}

/* ================= APP ROOT ================= */
export default function App() {
  return <AppLayout />;
}
